import { useEffect, useState } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import Form from "../../../form/Form";
import useForm from "../../../../hooks/useForm";
import Input from "../../../form/Input";
import { tableAddEdit, tableDetails } from "../../../../services/tableService";
import Button from "../../../form/Button";
import { useBistroNavigation } from "../../../../hooks/useBistroNavigation";

const ManageTable = ({ open, close = () => {}, getResponse = () => {}, data = {} }) => {
  const { getPath, config } = useBistroNavigation();
  const validation = {
    tableNumber: {
      required: true,
      message: "Table number is required",
    },
    tableName: {
      required: true,
      message: "Table name is required",
    },
  };

  const { values, handleChange, handleSubmit, errors, setFieldsValue, resetField, formValidate } = useForm({
    validationRules: validation,
    initialState: { status: "active" },
  });

  const {
    data: details,
    isLoading: detailsLoading,
    isFetching: detailsFetching,
  } = useQuery({
    queryKey: ["table-details", data?._id],
    queryFn: async () => {
      const res = await tableDetails({ id: data?._id });
      return res?.data;
    },
    enabled: !!data?._id,
  });

  useEffect(() => {
    if (details?._id) {
      setFieldsValue({
        tableNumber: details?.tableNumber || "",
        tableName: details?.tableName || "",
      });
    }
  }, [details]);

  const {
    mutate: onSubmit,
    error,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      const payload = {
        tableNumber: val?.tableNumber,
        tableName: val?.tableName,
        organization:config?._id
      };
      return await tableAddEdit(
        details?._id
          ? {
              id: details?._id,
              ...payload,
            }
          : {
              ...payload,
            }
      );
    },
    onSuccess: (res) => {
      getResponse(res);
      if (res?.status === 200 || res?.status === 201) {
        resetField();
        toast.success(res?.message || "Table saved successfully");
      }
      return res;
    },
    onError: (error) => {
      console.log(error);
      toast.error(error?.message || "Something went wrong");
    },
  });

  return (
    <div className="relative px-4 xls:px-3 py-3">
      <Form onSubmit={onSubmit} handleSubmit={handleSubmit} loading={detailsLoading}>
        <div className="max-w-2xl mx-auto xls:px-6 py-6">
          <div className="grid grid-cols-1 gap-4">
            <Input
              label={"Table Number"}
              inputType={"number"}
              inputPlaceholder="Enter table number"
              inputName="tableNumber"
              value={values?.tableNumber || ""}
              onChange={handleChange}
              {...formValidate(errors, "tableNumber")}
            />

            <Input
              label={"Table Name"}
              inputType={"text"}
              inputPlaceholder="Enter table name"
              inputName="tableName"
              value={values?.tableName || ""}
              onChange={handleChange}
              {...formValidate(errors, "tableName")}
            />
          </div>

          <div className="pt-6 pb-6 flex justify-end">
            <Button
              buttonType="submit"
              buttonClasses={"min-w-36 hover:bg-emerald-700"}
              buttonLabel={details?._id ? "Update" : "Save"}
              {...((isLoading || detailsLoading) && {
                loading: true,
                buttonIconPosition: "left",
                isDisable: true,
              })}
            />
          </div>
        </div>
      </Form>
    </div>
  );
};

export default ManageTable;